/**
 * Live help component
 */
(function () {
    'use strict';

    var ItxStyleAdvisorCmp = {
        controller: ItxStyleAdvisorCmpCtrl,
        bindings: {
            config: '<'
        }
    };

    ItxStyleAdvisorCmpCtrl.$inject = ['ItxStyleAdvisorSvc'];

    function ItxStyleAdvisorCmpCtrl(ItxStyleAdvisorSvc) {
        var _this = this;

        _this.$onInit = function () {
            ItxStyleAdvisorSvc.initWidget(_this.config);
        };
    }

    angular.module('itxApp.common').component('itxStyleAdvisor', ItxStyleAdvisorCmp);
})(window.itxApp);
